// To add new fonts, checkout README_fonts.md
export const fonts = [
  'Barlow',
  'Fira Sans',
  'Gelasio',
  'Lato',
  'Merriweather',
  'Montserrat',
  'Mulish',
  'Nunito Sans',
  'Nunito',
  'Open Sans',
  'Oswald',
  'Playfair Display',
  'Poppins',
  'Public Sans',
  'Raleway',
  'Roboto Slab',
  'Roboto Condensed',
  'Roboto',
  'Source Sans Pro',
  'Spectral',
  'Work Sans',
]
